













































































































































































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@/utils/common";
import { Table } from "@/utils/decorator";
import dayjs from "dayjs";

const finance = namespace("finance");
@Component({})
@Table("loadListData")
export default class TmallBillView extends Vue {
  @finance.Action getPaymentDetail;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  dayjs = dayjs;
  get breadData() {
    return [
      { name: window._I18N.t("finance.payment-order"), path: "/finance/payment-order" },
      { name: window._I18N.t("finance.bill-payment-details") }
    ];
  }
  get paymentId() {
    return this.$route.params.id;
  }
  get type() {
    // 字典值 1：天猫 2：销售 9：其他
    return String(this.detailData.paymentType);
  }
  handleLinkServiceView(row) {
    let { href } = this.$router.resolve({
      path: `/purchase/purchase-view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  orderList: any[] = [];
  tableLoading: boolean = false;
  detailData: any = {};
  created() {
    this.init();
  }
  init() {
    this.loadListData();
  }
  handleLinkTmallBill(billNo) {
    let { href } = this.$router.resolve({
      path: `/finance/tmall-bill-view/${billNo}`
    });
    window.open(href, "_blank");
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getPaymentDetail({
      paymentNo: this.paymentId,
      orderItems: this.mix_sortParams,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.detailData = data.data;
      this.orderList = data.data.orderList;
      return data;
    });
  }
}
